/**
 * Color intention that you want to used in your theme
 * @param {JsonObject} theme Theme customization object
 */

export default function themePalette(theme: any) {
  return {
    mode: theme?.customization?.navType,
    common: {
      black: theme?.colors?.darkPaper
    },
    primary: {
      light: theme?.colors?.primaryLight,
      main: theme?.colors?.primaryMain,
      dark: theme?.colors?.primaryDark,
      200: theme?.colors?.primary200,
      800: theme?.colors?.primary800
    },
    secondary: {
      light: theme?.colors?.secondaryLight,
      green: theme?.colors?.menuBackgroundPrimary,
      main: theme?.colors?.secondaryMain,
      dark: theme?.colors?.secondaryDark,
      200: theme?.colors?.secondary200,
      800: theme?.colors?.secondary800
    },
    error: {
      light: theme?.colors?.errorLight,
      main: theme?.colors?.errorMain,
      dark: theme?.colors?.errorDark
    },
    orange: {
      light: theme?.colors?.orangeLight,
      main: theme?.colors?.orangeMain,
      dark: theme?.colors?.orangeDark
    },
    warning: {
      light: theme?.colors?.warningLight,
      main: theme?.colors?.warningMain,
      dark: theme?.colors?.warningDark,
      50: theme?.colors?.warning50,
      100: theme?.colors?.warning100,
      200: theme?.colors?.warning200,
      300: theme?.colors?.warning300,
      400: theme?.colors?.warning400,
      500: theme?.colors?.warning500,
      600: theme?.colors?.warning600,
      700: theme?.colors?.warning700,
      800: theme?.colors?.warning800,
      900: theme?.colors?.warning900
    },
    success: {
      light: theme?.colors?.successLight,
      main: theme?.colors?.successMain,
      dark: theme?.colors?.successDark,
      50: theme?.colors?.success50,
      100: theme?.colors?.success100,
      200: theme?.colors?.success200,
      300: theme?.colors?.success300,
      400: theme?.colors?.success400,
      500: theme?.colors?.success500,
      600: theme?.colors?.success600,
      700: theme?.colors?.success700,
      800: theme?.colors?.success800,
      900: theme?.colors?.success900
    },
    grey: {
      50: theme?.colors?.grey50,
      100: theme?.colors?.grey100,
      500: theme?.darkTextSecondary,
      600: theme?.heading,
      700: theme?.darkTextPrimary,
      900: theme?.textDark
    },
    dark: {
      light: theme?.colors?.darkTextPrimary,
      main: theme?.colors?.darkLevel1,
      dark: theme?.colors?.darkLevel2,
      800: theme?.colors?.darkBackground,
      900: theme?.colors?.darkPaper,
      50: theme?.colors?.dark50,
      400: theme?.colors?.dark400
    },
    text: {
      primary: theme?.darkTextPrimary,
      secondary: theme?.darkTextSecondary,
      dark: theme?.textDark,
      hint: theme?.colors?.grey100
    },
    background: {
      paper: theme?.paper,
      default: theme?.backgroundDefault
    },
    violet: {
      50: theme?.colors?.violet50,
      100: theme?.colors?.violet100,
      200: theme?.colors?.violet200,
      300: theme?.colors?.violet300,
      400: theme?.colors?.violet400,
      500: theme?.colors?.violet500,
      600: theme?.colors?.violet600,
      700: theme?.colors?.violet700,
      800: theme?.colors?.violet800,
      900: theme?.colors?.violet900
    },
    neutral: {
      50: theme?.colors?.neutral50,
      100: theme?.colors?.neutral100,
      200: theme?.colors?.neutral200,
      300: theme?.colors?.neutral300,
      400: theme?.colors?.neutral400,
      500: theme?.colors?.neutral500,
      600: theme?.colors?.neutral600,
      700: theme?.colors?.neutral700,
      800: theme?.colors?.neutral800,
      900: theme?.colors?.neutral900
    },
    blue: {
      50: theme?.colors?.blue50,
      100: theme?.colors?.blue100,
      200: theme?.colors?.blue200,
      300: theme?.colors?.blue300,
      400: theme?.colors?.blue400,
      500: theme?.colors?.blue500,
      600: theme?.colors?.blue600,
      700: theme?.colors?.blue700,
      800: theme?.colors?.blue800,
      900: theme?.colors?.blue900
    },
    lightGreen: {
      50: theme?.colors?.lightGreen50,
      100: theme?.colors?.lightGreen100,
      200: theme?.colors?.lightGreen200,
      300: theme?.colors?.lightGreen300,
      400: theme?.colors?.lightGreen400,
      primaryGreen: theme?.colors?.lightGreen500,
      600: theme?.colors?.lightGreen600,
      700: theme?.colors?.lightGreen700,
      800: theme?.colors?.lightGreen800,
      900: theme?.colors?.lightGreen900
    },
    red: {
      50: theme?.colors?.red50,
      100: theme?.colors?.red100,
      200: theme?.colors?.red200,
      300: theme?.colors?.red300,
      400: theme?.colors?.red400,
      500: theme?.colors?.red500,
      600: theme?.colors?.red600,
      700: theme?.colors?.red700,
      800: theme?.colors?.red800,
      900: theme?.colors?.red900
    }
  }
}
